export const STATUS = {
	AGUARDANDO_PRESTACAO_CONTAS: 1,
	AGUARDANDO_ANALISE: 2,
	EM_ANALISE: 3,
	EM_DILIGENCIA: 4,
	ARQUIVADO: 5,
	AGUARDANDO_REVISAO: 6,
};

export const LOCAL = {
	MUNICIPIO: 1,
	CREPDEC: 2,
	DACA: 3,
	SUB_CHEFIA: 4,
};

export const STATUS_OCORRENCIA = {
	SEM_REGISTRO: 'SEM_REGISTRO',
	COM_REGISTRO: 'COM_REGISTRO',
	EMERGENCIA: 'EMERGENCIA',
	CALAMIDADE: 'CALAMIDADE',
	HOMOLOGADO: 'HOMOLOGADO',
	RECONHECIDO: 'RECONHECIDO',
};
